export default {
    meta: {
        title: '创建拓店任务',
        url: '/standardstore/tasklist',
        urlName: '标准版拓店-拓店任务'
    }
};
